<template>
  <div>
    <div v-if="isMobile">
      <MHome />
    </div>
    <div v-else>
      <PCHome />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import PCHome from "./pc/PCHome.vue";
import MHome from "./m/MHome.vue";
import { logEventFun as $logEvent } from "./pc/gn/log";
export default {
  name: "Home",
  provide() {
    return { home: this };
  },
  data() {
    return {
      extendObj: {},
      host: 'https://t.novel.link',
      isMobile: false,
      browseLanguage: "",
    };
  },
  components: {
    MHome,
    PCHome,
  },
  mounted() {
    this.initUUID();
    const params = this.$route.params;
    if (params && params.shortLink) {
      this.init(decodeURIComponent(params.shortLink));
    } else {
      this.setDefault();
      this.initTitle();
    }
    this.initBrowseLanugage();
  },
  computed: {
    downloadUrl() {
      return this.host + '/' + this.$route.params.shortLink + '?from=1';
    },
  },
  methods: {
    initBrowseLanugage() {
      const language = navigator.language;
      if (language) {
        this.browseLanguage = language.split("-")[0];
      }
    },
    initUUID() {
      try {
        const uuid = this.getUUID();
        localStorage.setItem("UUID", uuid);
      } catch (error) {

      }
    },
    getUUID() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4";
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = "-";
      var uuid = s.join("");
      return uuid;
    },
    async init(shortLink) {
      try {
        const res = await axios.post('/hwyc/link/parseLink', { shortLink });
        if (res.status === 200 && res.data && res.data.status === 0 && res.data.data && res.data.data.extendStr) {
          this.extendObj = JSON.parse(res.data.data.extendStr);
          $logEvent({
            event: "app_down_page_request_success", //下载app
            map: {
              ...this.extendObj,
              shortLink: shortLink,
              status: res.data.status
            },
          });
        } else {
          this.setDefault();
          $logEvent({
            event: "app_down_page_request_failed", //下载app
            map: {
              shortLink: shortLink,
              status: res.data && res.data.status
            },
          });
        }
      } catch (error) {
        this.setDefault();
        $logEvent({
          event: "app_down_page_request_failed", //下载app
          map: {
            shortLink: shortLink,
            error: JSON.stringify(error)
          },
        });
      }
      this.initTitle();
    },
    setDefault() {
      this.extendObj = {
        production: 'https://m.goodnovel.com/',
        channelCode: "GWEB00001",
        bookId: "0",
        site: 'gn',
      };
    },
    getMobile(ua) {
      if (/googlebot/i.test(ua)) {
        if (/Mobile/i.test(ua)) {
          return true;
        } else {
          return false;
        }
      } else if (/bingbot/i.test(ua)) {
        if (/Mobile/i.test(ua)) {
          return true;
        } else {
          return false;
        }
      } else if (/applebot/i.test(ua)) {
        if (/Mobile/i.test(ua)) {
          return true;
        } else {
          return false;
        }
      } else if (/YandexBot/i.test(ua)) {
        if (/Mobile/i.test(ua)) {
          return true;
        } else {
          return false;
        }
      }

      if (/iPhone|Android/i.test(ua)) {
        return true;
      }

      // if ( $http_user_agent ~ "(MIDP)|(WAP)|(UP.Browser)|(Smartphone)|(Obigo)|(Mobile)|(AU.Browser)|(wxd.Mms)|(WxdB.Browser)|(CLDC)|(UP.Link)|(KM.Browser)|(UCWEB)|(SEMC\-Browser)|(Mini)|(Symbian)|(Palm)|(Nokia)|(Panasonic)|(MOT\-)|(SonyEricsson)|(NEC\-)|(Alcatel)|(Ericsson)|(BENQ)|(BenQ)|(Amoisonic)|(Amoi\-)|(Capitel)|(PHILIPS)|(SAMSUNG)|(Lenovo)|(Mitsu)|(Motorola)|(SHARP)|(WAPPER)|(LG\-)|(LG/)|(EG900)|(CECT)|(Compal)|(kejian)|(Bird)|(BIRD)|(G900/V1.0)|(Arima)|(CTL)|(TDG)|(Daxian)|(DAXIAN)|(DBTEL)|(Eastcom)|(EASTCOM)|(PANTECH)|(Dopod)|(Haier)|(HAIER)|(KONKA)|(KEJIAN)|(LENOVO)|(Soutec)|(SOUTEC)|(SAGEM)|(SEC\-)|(SED\-)|(EMOL\-)|(INNO55)|(ZTE)|(iPhone)|(Android)|(Windows CE)|(Wget)|(Java)|(curl)|(Opera)" ){
      // 	rewrite ^/(.*) https://m.goodnovel.com/$1 last;
      // 	#rewrite ^/(.*) https://m3.goodnovel.com/$1 last;
      // }

      if (/(MIDP)|(WAP)|(UP.Browser)|(Smartphone)|(Obigo)|(Mobile)|(AU.Browser)|(wxd.Mms)|(WxdB.Browser)|(CLDC)|(UP.Link)|(KM.Browser)|(UCWEB)|(SEMC\-Browser)|(Mini)|(Symbian)|(Palm)|(Nokia)|(Panasonic)|(MOT\-)|(SonyEricsson)|(NEC\-)|(Alcatel)|(Ericsson)|(BENQ)|(BenQ)|(Amoisonic)|(Amoi\-)|(Capitel)|(PHILIPS)|(SAMSUNG)|(Lenovo)|(Mitsu)|(Motorola)|(SHARP)|(WAPPER)|(LG\-)|(LG\/)|(EG900)|(CECT)|(Compal)|(kejian)|(Bird)|(BIRD)|(G900\/V1.0)|(Arima)|(CTL)|(TDG)|(Daxian)|(DAXIAN)|(DBTEL)|(Eastcom)|(EASTCOM)|(PANTECH)|(Dopod)|(Haier)|(HAIER)|(KONKA)|(KEJIAN)|(LENOVO)|(Soutec)|(SOUTEC)|(SAGEM)|(SEC\-)|(SED\-)|(EMOL\-)|(INNO55)|(ZTE)|(iPhone)|(Android)|(Windows CE)|(Wget)|(Java)|(curl)|(Opera)/i.test(ua)) {
        return true;
      }

      return false;
    },
    initTitle() {
      let title = 'Click to read the book';
      const site = this.extendObj.site;
      if (this.isMobile) {
        if (site === 'gn') {
          title = "Click to read the book";
        } else if (site === 'bn') {
          title = "Haga clic para continuar leyendo";
          if (this.browseLanguage === 'pt') {
            title = "Clique para continuar lendo";
          }
        } else if (site === 'mn') {
          title = "Click to read the book";
        } else if (site === 'gf') {
          title = "Click to listen the book";
        } else if (site === 'gs') {
          title = "Click to continue watching";
        }
      } else {
        if (site === 'gn') {
          title = "Scan to read the book";
        } else if (site === 'bn') {
          title = "Escanear para continuar leyendo";
          if (this.browseLanguage === 'pt') {
            title = "Digitalize para continuar lendo";
          }
        } else if (site === 'mn') {
          title = "Scan to read the book";
        } else if (site === 'gf') {
          title = "Scan to listen the book";
        } else if (site === 'gs') {
          title = "Scan to continue watching";
        }
      }
      document.title = title;
    },
  },
  created() {
    this.isMobile = this.getMobile(window.navigator.userAgent);
  },
};
</script>

<style lang="scss">
.home {
  color: red;
  font-size: 20px;
}
</style>
